module.exports = "/assets/site/images/MVM_foci.jpg?22984aeda17722a192d8847f716a7d6e";